import { useCallback, useContext } from 'react'
import ModalContext from 'contexts/ModalContext'
import JourneyV2DetailsModal from 'components/Flights/V2/FareFamily/JourneyV2DetailsModal'
import DrawerFlightCard from 'tripPlanner/components/Chat/Flights/DrawerFlightCard'

interface Props {
  journey: App.JourneyV2
  onSelect?: (data: { journey: App.JourneyV2 }) => void
  isAlreadyAdded: boolean
  isCartMode: boolean
  isCartSubmitting: boolean
  showSelectButton: boolean
}

function FlightSearchResultCard({
  journey,
  onSelect,
  isAlreadyAdded,
  isCartMode,
  isCartSubmitting,
  showSelectButton,
}: Props) {
  const showModal = useContext(ModalContext)
  const handleViewDetails = useCallback(() => {
    showModal(<JourneyV2DetailsModal journey={journey} />)
  }, [journey, showModal])

  return (
    <DrawerFlightCard
      journey={journey}
      onSelect={onSelect}
      onViewDetails={handleViewDetails}
      isAlreadyAdded={!isCartMode && isAlreadyAdded}
      isSelectDisabled={isCartMode && isCartSubmitting}
      showSelectButton={showSelectButton}
      alignColumns
    />
  )
}

export default FlightSearchResultCard
